"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cancelCircle = _interopRequireDefault(require("cccisd-icons/cancel-circle"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _default = exports["default"] = function _default(props) {
  var field = props.field,
    icons = props.icons;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPicker = _useState2[0],
    setShowPicker = _useState2[1];
  var handleShowPicker = function handleShowPicker() {
    setShowPicker(true);
  };
  var onChangeIcon = function onChangeIcon(icon) {
    field.onChange(icon);
    setShowPicker(false);
  };
  var getSelectedIcon = function getSelectedIcon() {
    var selectedIcon = icons.find(function (icon) {
      return icon.id === field.value;
    });
    return selectedIcon || icons[0];
  };
  var handleClosePicker = function handleClosePicker() {
    setShowPicker(false);
  };
  var selectedIcon = getSelectedIcon();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].picker
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "tabDisplay"
  }, props.label), /*#__PURE__*/_react["default"].createElement("div", {
    id: "tabDisplay",
    className: _style["default"].pickerButton,
    onClick: handleShowPicker
  }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
    viewBox: selectedIcon.viewBox,
    key: selectedIcon.id
  }, /*#__PURE__*/_react["default"].createElement("g", null, selectedIcon.paths.map(function (p, index) {
    return /*#__PURE__*/_react["default"].createElement("path", {
      key: index,
      d: p
    });
  })))), showPicker && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].cover,
    onClick: handleClosePicker
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].iconPicker,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].arrow
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].arrow2
  }), icons.map(function (icon) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: icon.id
    }, icon.id === 'none' || icon.id === '' ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "No Icon",
      key: icon.id
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn btn-secondary ' + (field.value === icon.id ? 'active' : ''),
      onClick: function onClick() {
        onChangeIcon(icon.id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_cancelCircle["default"], null))) : /*#__PURE__*/_react["default"].createElement("button", {
      key: icon.id,
      type: "button",
      className: 'btn btn-secondary ' + (field.value === icon.id ? 'active' : ''),
      onClick: function onClick() {
        onChangeIcon(icon.id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
      viewBox: icon.viewBox,
      key: icon.id
    }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: index,
        d: p
      });
    })))));
  }))));
};